// @ts-check
import { FEATURE_FLAGS } from '../../../../common/consts/featureFlags';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { DisabledGdprConsent } from './DisabledGdprConsent';
import { EnabledGdprConsent } from './EnabledGdprConsent';
import { StyledTermsAndPolicy } from './TermsAndPolicy.style';

const TermsAndPolicy = () => {
  const enableGdprConsent = useFeatureFlag(FEATURE_FLAGS.GDPR_CONSENT);

  return (
    <StyledTermsAndPolicy>
      {enableGdprConsent ? <EnabledGdprConsent /> : <DisabledGdprConsent />}
    </StyledTermsAndPolicy>
  );
};

export default TermsAndPolicy;
